import ArticlesAuthorSubPage, { getServerSideProps as defaultGetServerSideProps } from '../[author]'

export const getServerSideProps = defaultGetServerSideProps

export default ArticlesAuthorSubPage
